import React from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import CalloutArea from '../CalloutArea/CalloutArea';
import MediaList from '../MediaList/MediaList';
import Button from '../Button/Button';

import appData from '../../data/app.json';
import panelData from '../../data/panel.json';

import './Panel.css';

class Panel extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			timer: 0,
		};
	}

	render() {
		const panels = (this.props.panel > -1 && panelData[this.props.panel]) || panelData[appData.sections[this.props.currentSection].panel] || panelData[appData.sections[this.props.currentSection].groups[this.props.currentGroup].stages[this.props.currentStage].panel];
		// console.log('panels', panels);
		return (
			<section className={'panel ' + ((panels && panels[0] && panels[0].style) || '')}>
				{
					panels && panels.map(function(item, pos) {
						if (item.type === 'para') {
							return (
								<section key={item.id} className={`panel__para ${item.style}`}>
									<h4 className="panel__paraHeader">{item.header}</h4>
									<p className="panel__paraText">{item.para}</p>
								</section>
							);
						}
						if (item.type === 'calloutArea') {
							return <CalloutArea key={item.id} data={item.calloutArea} />;
						}
						if (item.type === 'button') {
							return <Button key={item.id} 
								className={"panel-button " + (item.className || '') } 
								action={item.action}
								title={item.title || item.text}
								destination={item.destination}>
								{item.text}
							</Button>;
						}
						if (item.type === 'list') {
							return (
								<section key={"panel-list-"+pos}>
									{ item.title && 
										<h4>{item.title}</h4>
									}
									<ul key="panel__ul" className="panel__list">
										{
											item.list.map(item => (
												<li className="panel__listItem" key={item.id}>{item.text}</li>
											))
										}
									</ul>
								</section>
							)
						}
						if (item.type === 'mediaList') {
							return (
								<MediaList key={item.id} media={item.media} fixToBottom={item.fixToBottom} />
							)
						}
						if (item.type === 'intro') {
							return (
								<section key={item.id} className="panel__intro">
									<h3 className="panel__introTitle">
										{item.title}
									</h3>
									<h4 className="panel__introSubtitle">
										{item.subtitle}
									</h4>
									<p className="panel__introBody">
										{item.body}
									</p>
								</section>
							)
						}
						return '';
					})
				}
			</section>
		);
	}
}

function mapStateToProps(state) {
	return {
		currentSection: state.navigation.currentSection,
		currentGroup: state.navigation.currentGroup,
		currentStage: state.navigation.currentStage
	};
}

Panel.propTypes = {
	currentSection: propTypes.number.isRequired,
	currentGroup: propTypes.number,
	currentStage: propTypes.number,
	panel: propTypes.number
};

export default connect(mapStateToProps)(Panel);



// WEBPACK FOOTER //
// ./src/components/Panel/Panel.js